import { Box, Tag, TagLabel, TagLeftIcon, Tooltip } from "@chakra-ui/react";
import React from "react";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";
import { useFormTemplateContext } from "../../../formTemplateContext";
import { useEditFormTemplateContext } from "../context";

type Props = { id: string };
export const SectionChangesIndicator: React.FC<Props> = ({
  id: sectionId,
}: Props) => {
  const { mode } = useFormTemplateContext();
  const { state, isPublishedMode, helpers } = useEditFormTemplateContext();
  const diff = state.get("diff");

  if (helpers.isUnsavedSection(sectionId)) {
    return (
      <Tooltip label="This section has changes that haven’t been saved yet.">
        <Box as="span" alignSelf="flex-start">
          <UnsavedChanges />
        </Box>
      </Tooltip>
    );
  }

  if (mode === "view") {
    return null;
  }

  if (!isPublishedMode) {
    return null;
  }

  switch (diff.sections[sectionId]) {
    case "Insert":
    case "Update":
      return (
        <Tooltip label="This section has changes that haven’t been published and are not visible yet.">
          <Box as="span" alignSelf="flex-start">
            <UnpublishedChanges />
          </Box>
        </Tooltip>
      );

    default:
      return null;
  }
};

export const QuestionChangesIndicator: React.FC<Props> = ({
  id: questionId,
}) => {
  const { mode } = useFormTemplateContext();
  const { state, isPublishedMode, helpers } = useEditFormTemplateContext();
  const diff = state.get("diff");

  if (helpers.isUnsavedQuestion(questionId)) {
    return (
      <Tooltip label="This question has changes that haven’t been saved yet.">
        <Box as="span" alignSelf="flex-start">
          <UnsavedChanges />
        </Box>
      </Tooltip>
    );
  }

  if (mode === "view") {
    return null;
  }

  if (!isPublishedMode) {
    return null;
  }

  switch (diff.questions[questionId]) {
    case "Insert":
    case "Update":
      return (
        <Tooltip label="This question has changes that haven’t been published and are not visible yet.">
          <Box as="span" alignSelf="flex-start">
            <UnpublishedChanges />
          </Box>
        </Tooltip>
      );

    default:
      return null;
  }
};

const UnsavedChanges = () => (
  <Tag colorScheme="orange" variant="outline">
    <TagLeftIcon as={RiCheckboxBlankCircleFill} color="orange.100" />
    <TagLabel>Unsaved changes</TagLabel>
  </Tag>
);

const UnpublishedChanges = () => (
  <Tag colorScheme="blue" variant="outline">
    <TagLeftIcon as={RiCheckboxBlankCircleFill} color="blue.100" />
    <TagLabel>Unpublished changes</TagLabel>
  </Tag>
);
